export enum ExportProtocol {
    FTP = 'ftp',
    SFTP = 'sftp',
    FTPS = 'ftps',
    Webhook = 'webhook'
}
